(() => {
  if(!customElements.get('mfc-collection-count'))customElements.define('mfc-collection-count',class extends HTMLElement{
    connectedCallback(){
      const source=document.getElementById('ProductCount');if(!source)return;
      const update=()=>{this.textContent=source.textContent.trim();};
      this.observer=new MutationObserver(update);this.observer.observe(source,{subtree:true,childList:true,characterData:true});update();
    }
    disconnectedCallback(){this.observer?.disconnect();}
  });
  if(!customElements.get('mfc-product-card'))customElements.define('mfc-product-card',class extends HTMLElement{
    connectedCallback(){
      this.abort=new AbortController();queueMicrotask(()=>{
        if(!this.isConnected)return;
        const card=this.querySelector('.card');const image=card?.querySelector('.card__inner');const quick=card?.querySelector('.quick-add');
        if(this.hasAttribute('data-overlay')&&image&&quick){
          this.append(quick);quick.classList.add('mfc-overlay-add');
          this.resize=new ResizeObserver(()=>this.style.setProperty('--mfc-image-height',`${image.getBoundingClientRect().height}px`));this.resize.observe(image);
          const button=quick.querySelector('button');const icon=this.querySelector('[data-mfc-add-icon]')?.content.firstElementChild;
          if(button&&icon&&!button.querySelector('.mfc-add-icon')){button.setAttribute('title',button.textContent.trim());button.append(icon.cloneNode(true));}
          quick.addEventListener('click',event=>{if(event.target.closest('button'))event.stopPropagation();},{signal:this.abort.signal});
        }
        const swatches=this.querySelector('.mfc-swatches');const info=card?.querySelector(':scope>.card__content .card__information');if(swatches&&info)info.append(swatches);
        this.addEventListener('click',event=>{
          const swatch=event.target.closest('[data-mfc-color]');if(!swatch||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey)return;
          event.preventDefault();this.querySelectorAll('[data-mfc-color]').forEach(e=>e.removeAttribute('aria-current'));swatch.setAttribute('aria-current','true');
          this.classList.add('mfc-color-selected');
          const img=image?.querySelector('.card__media img');if(img&&swatch.dataset.image){img.removeAttribute('srcset');img.src=swatch.dataset.image;img.alt=swatch.dataset.alt||'';}
          card.querySelectorAll('a.full-unstyled-link').forEach(e=>e.href=swatch.href);
          quick?.querySelectorAll('[data-product-url]').forEach(e=>e.dataset.productUrl=swatch.getAttribute('href'));
          quick?.querySelectorAll('[data-mfc-url]').forEach(e=>e.dataset.mfcUrl=swatch.getAttribute('href'));
          const price=swatch.querySelector('[data-mfc-price]')?.content.firstElementChild;const target=card.querySelector('.card-information>.price');if(price&&target)target.replaceWith(price.cloneNode(true));
          const status=this.querySelector('[data-mfc-color-status]');if(status)status.textContent=swatch.getAttribute('aria-label');
        },{signal:this.abort.signal});
      });
    }
    disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();}
  });
  document.addEventListener('input',event=>{
    const select=event.target.closest('.mfc-grid #FacetSortDrawerForm select');if(!select)return;
    const root=select.closest('.mfc-grid');const mobile=root.querySelector('#FacetFiltersFormMobile');if(!mobile||typeof FacetFiltersForm==='undefined')return;
    event.stopImmediatePropagation();const params=new URLSearchParams(new FormData(mobile));params.set('sort_by',select.value);
    const inside=mobile.querySelector('[name="sort_by"]');if(inside)inside.value=select.value;
    FacetFiltersForm.renderPage(params.toString(),event);
  },true);
})();

